<template>
  <Modal :value="value" @input="close">

    <h3 slot="header" class="my-2">
      {{ additive ? 'Editar aditivo' : 'Novo aditivo contratual' }}
    </h3>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="additive-description">Descrição *</label>
          <input v-model="form.description" id="additive-description" type="text" class="form-control"
                 placeholder="Ex.: Inclusão do CaçaMultas Taxas">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="additive-signed">Assinado em</label>
          <input v-model="form.signed_at" id="additive-signed" type="date" class="form-control">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="additive-effective">Vigência a partir de</label>
          <input v-model="form.effective_from" id="additive-effective" type="date" class="form-control">
        </div>
      </div>

      <div class="col-md-12">
        <label>Arquivo (PDF)</label>

        <div v-if="selectedName" class="selected-file">
          <file-text-icon size="1x" class="mr-2"/>
          <span>{{ selectedName }}</span>
          <button @click="clearFile" class="clear-file" title="Remover arquivo">
            <x-icon size="1x"/>
          </button>
        </div>

        <Upload v-else class="upload" :is-multiple="false" accept="application/pdf,.pdf" :method="setFile">
          <upload-cloud-icon size="2x" class="upload-icon"/>
          <p class="mb-0">Selecione ou arraste o PDF do aditivo</p>
        </Upload>
      </div>
    </div>

    <template slot="footer">
      <button @click="close" class="btn btn-outline mr-1">Cancelar</button>
      <button @click="submit" class="btn btn-primary">
        {{ additive ? 'Salvar aditivo' : 'Adicionar aditivo' }}
      </button>
    </template>

  </Modal>
</template>

<script>
  import { FileTextIcon, UploadCloudIcon, XIcon } from 'vue-feather-icons'

  import Modal from '@/components/shares/specialTag/Modal'
  import Upload from '@/components/shares/specialTag/Upload'
  import { ADDITIVE_DESCRIPTION_ERROR, PDF_ERROR, isPdf } from '@/models/accountContract'

  const emptyForm = () => ({
    description: '',
    signed_at: '',
    effective_from: '',
    file: null
  })

  export default {
    components: { FileTextIcon, Modal, Upload, UploadCloudIcon, XIcon },
    computed: {
      selectedName() {
        if (this.pendingFile)
          return this.pendingFile.name

        return this.form.file ? this.form.file.name : null
      }
    },
    data() {
      return {
        form: emptyForm(),
        pendingFile: null
      }
    },
    methods: {
      clearFile() {
        this.pendingFile = null
        this.form.file = null
      },
      close() {
        this.$emit('input', false)
      },
      reset() {
        this.form = this.additive ? { ...emptyForm(), ...this.additive } : emptyForm()
        this.pendingFile = null
      },
      setFile(files) {
        const file = files[0]

        if (!file)
          return

        if (!isPdf(file))
          return this.$notify.addError(PDF_ERROR)

        this.pendingFile = file
      },
      submit() {
        if (!String(this.form.description || '').trim())
          return this.$notify.addError(ADDITIVE_DESCRIPTION_ERROR)

        this.$emit('save', { additive: { ...this.form }, file: this.pendingFile })
        this.close()
      }
    },
    name: 'AdditiveModal',
    props: {
      additive: { default: null, type: Object },
      value: { required: true, type: Boolean }
    },
    watch: {
      value(opened) {
        if (opened)
          this.reset()
      }
    }
  }
</script>

<style scoped>
  .upload {
    position: relative;
    z-index: 1;
  }

  .upload-icon {
    color: var(--icon-color);
  }

  .selected-file {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    margin: 16px 0;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    background: var(--light-gray);
    font-size: 14px;
  }

  .clear-file {
    margin-left: auto;
    padding: 2px;
    border: none;
    background: none;
    color: var(--icon-color);
    cursor: pointer;
  }

  .clear-file:hover {
    color: #d9534f;
  }
</style>
